import { createGlobalStyle } from 'styled-components/macro';

import MulishBold from 'assets/fonts/Mulish/Mulish-Bold.ttf';
import MulishLight from 'assets/fonts/Mulish/Mulish-Light.ttf';
import MulishBlack from 'assets/fonts/Mulish/Mulish-Black.ttf';
import MulishItalic from 'assets/fonts/Mulish/Mulish-Italic.ttf';
import MulishMedium from 'assets/fonts/Mulish/Mulish-Medium.ttf';
import MulishRegular from 'assets/fonts/Mulish/Mulish-Regular.ttf';
import MulishSemiBold from 'assets/fonts/Mulish/Mulish-SemiBold.ttf';
import MulishExtraBold from 'assets/fonts/Mulish/Mulish-ExtraBold.ttf';
import MulishExtraLight from 'assets/fonts/Mulish/Mulish-ExtraLight.ttf';
import MulishBoldItalic from 'assets/fonts/Mulish/Mulish-BoldItalic.ttf';
import MulishLightItalic from 'assets/fonts/Mulish/Mulish-LightItalic.ttf';
import MulishBlackItalic from 'assets/fonts/Mulish/Mulish-BlackItalic.ttf';
import MulishMediumItalic from 'assets/fonts/Mulish/Mulish-MediumItalic.ttf';
import MulishSemiBoldItalic from 'assets/fonts/Mulish/Mulish-SemiBoldItalic.ttf';
import MulishExtraBoldItalic from 'assets/fonts/Mulish/Mulish-ExtraBoldItalic.ttf';
import MulishExtraLightItalic from 'assets/fonts/Mulish/Mulish-ExtraLightItalic.ttf';

import { Theme } from 'common/types/theme.type';

export const StyledFonts = createGlobalStyle<{
  theme: Theme;
}>`
  @font-face {
    font-family: 'Mulish';
    font-weight: 200;
    font-style: normal;
    src: local('Mulish'), url(${MulishExtraLight}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 200;
    font-style: italic;
    src: local('Mulish'), url(${MulishExtraLightItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 300;
    font-style: normal;
    src: local('Mulish'), url(${MulishLight}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 300;
    font-style: italic;
    src: local('Mulish'), url(${MulishLightItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 400;
    font-style: normal;
    src: local('Mulish'), url(${MulishRegular}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 400;
    font-style: italic;
    src: local('Mulish'), url(${MulishItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 500;
    font-style: normal;
    src: local('Mulish'), url(${MulishMedium}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 500;
    font-style: italic;
    src: local('Mulish'), url(${MulishMediumItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 600;
    font-style: normal;
    src: local('Mulish'), url(${MulishSemiBold}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 600;
    font-style: italic;
    src: local('Mulish'), url(${MulishSemiBoldItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 700;
    font-style: normal;
    src: local('Mulish'), url(${MulishBold}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 700;
    font-style: italic;
    src: local('Mulish'), url(${MulishBoldItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 800;
    font-style: normal;
    src: local('Mulish'), url(${MulishExtraBold}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 800;
    font-style: italic;
    src: local('Mulish'), url(${MulishExtraBoldItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 900;
    font-style: normal;
    src: local('Mulish'), url(${MulishBlack}) format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    font-weight: 900;
    font-style: italic;
    src: local('Mulish'), url(${MulishBlackItalic}) format('truetype');
  }

  body {
    font-family: ${({ theme }) => theme.fonts.fontFamily};
    --bs-body-font-family: ${({ theme }) => theme.fonts.fontFamily};
    --bs-font-sans-serif: ${({ theme }) => theme.fonts.fontFamily};
  }
`;
